import React from 'react';

const ListItem = ({ myCart, setCart }) => {
    if (!myCart || myCart.qty === 0) {
        return (
            <div
                style={{
                    textAlign: 'center',
                    paddingTop: '20px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    color: 'var(--dark-grayish-blue)',
                }}
            >
                Your cart is empty.
            </div>
        );
    }
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    padding: '20px',
                }}
            >
                <img
                    src={myCart.img}
                    alt={myCart.title}
                    style={{
                        height: '45px',
                        borderRadius: '5px',
                    }}
                ></img>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: '10px',
                    }}
                >
                    <p
                        style={{
                            color: 'var(--dark-grayish-blue)',
                            fontSize: '14px',
                        }}
                    >
                        {myCart.title}
                    </p>

                    <p
                        style={{
                            color: 'var(--dark-grayish-blue)',
                            fontSize: '14px',
                        }}
                    >
                        {`$${myCart.price}.00 x ${myCart.qty}`}{' '}
                        <span
                            style={{
                                color: 'black',
                                fontSize: '14px',
                                fontWeight: 'bold',
                            }}
                        >
                            {' '}
                            {` $${myCart.total}.00`}
                        </span>
                    </p>
                </div>
                <div
                    onClick={() => {
                        setCart(undefined);
                    }}
                    style={{
                        marginLeft: 'auto',
                        cursor: 'pointer',
                    }}
                >
                    <svg width='14' height='16' xmlns='http://www.w3.org/2000/svg'>
                        <path
                            fill='#C3CAD9'
                            d='M0 2.625V1.75C0 1.334.334 1 .75 1h3.5l.294-.584A.741.741 0 0 1 5.213 0h3.571a.75.75 0 0 1 .672.416L9.75 1h3.5c.416 0 .75.334.75.75v.875a.376.376 0 0 1-.375.375H.375A.376.376 0 0 1 0 2.625Zm13 1.75V14.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 14.5V4.375C1 4.169 1.169 4 1.375 4h11.25c.206 0 .375.169.375.375ZM4.5 6.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Zm3 0c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Zm3 0c0-.275-.225-.5-.5-.5s-.5.225-.5.5v7c0 .275.225.5.5.5s.5-.225.5-.5v-7Z'
                            id='a'
                        />
                    </svg>
                </div>
            </div>
        </>
    );
};

export default ListItem;
